import { addClassNames } from './lib/utils/dom';
/**
 * Embed M.A.A.P. into a website as iframe.
 * @param options - Embedding options.
 * @param container - The container to append the iframe.
 * @param stylesheetUrl - Url of the stylesheet.
 * @param integrationUrl - Url of the MAAP integration.
 * @param hasAdvertisements - Whether the widget contains advertisements.
 */
export function embedMAAP(options) {
    // create the iframe and add a CSS class for styling
    const iframe = document.createElement('iframe');
    const iframeClassNames = ['mt-maap-embed'];
    if (options.hasAdvertisements)
        iframeClassNames.push('has-advertisements');
    addClassNames(iframe, iframeClassNames);
    // asemble the iframe's markup
    const iframeSrc = `
    <html class="maap_s-maap-embed">
    <head>
      <link rel="stylesheet" href="${options.stylesheetUrl}" type="text/css">
    </head>
    <body>
      <div id="maap"></div>
      <script src="${options.integrationUrl}"><\/script>
    </body>
    </html>`;
    // add it to the iframe
    iframe.src = 'data:text/html;charset=UTF-8,' + escape(iframeSrc);
    // set a title on the iframe
    iframe.title = 'M.A.A.P. leaflet widget';
    // allow going to fullscreen
    iframe.allowFullscreen = true;
    iframe.allow = 'fullscreen';
    // add is-loaded class when content is loaded
    iframe.onload = () => {
        iframe.classList.add('is-loaded');
    };
    // append the iframe to the container
    options.container.appendChild(iframe);
}
//# sourceMappingURL=embedMAAP.js.map